export default {
  // API_URL: 'http://localhost:3107/api/',
  // API_URL: 'http://citracom.co.id:3102/api/',
  // API_URL: window.location.protocol + '//' + window.location.hostname + ':3032/api/',
  API_URL: window.location.protocol + '//' + 'kotawaringinbarat-gis-api.itax.id/api/',

  // ENDPOINT: 'http://localhost:3107',
  // ENDPOINT: 'http://citracom.co.id:3102',
  // ENDPOINT: window.location.protocol + '//' + window.location.hostname + ':3032',
  ENDPOINT: window.location.protocol + '//' + 'kotawaringinbarat-gis.itax.id',

  homepage: '',
  GEOM_ESPG: 32749,
  LEAFLET_ESPG: 4326,
  proj4def: '+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs',
};
